import { render, staticRenderFns } from "./IntroScreenOne.vue?vue&type=template&id=21379a2a&scoped=true&lang=pug&"
import script from "./IntroScreenOne.vue?vue&type=script&lang=js&"
export * from "./IntroScreenOne.vue?vue&type=script&lang=js&"
import style0 from "./IntroScreenOne.vue?vue&type=style&index=0&id=21379a2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21379a2a",
  null
  
)

export default component.exports